<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/usa/napa')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/abreu-vineyards')">Abreu Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/caymus-vineyards')">Caymus vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/christian-moueix-dominus')">Christian Moueix -
                        Dominus
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/colgin-cellars')">Colgin Cellars
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/harlan-estates')">Harlan Estates
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/kapcsandy-winery')">Kapcsandy Winery
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/usa/napa/opus-one')">Opus One
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/robert-mondovi-vineyards')">Robert Mondovi
                        Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/scarecrow-wines')">Scarecrow Wines
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/schrader-cellars')">Schrader Cellars
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/screaming-eagle')">Screaming Eagle
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/usa/napa')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Opus Uno</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Dicono che non dimentichi mai il tuo primo. E come primo vino americano lanciato sulla piattaforma Vindome, pensiamo che Opus One sia davvero indimenticabile. Non solo è uno dei vini più ambiti al mondo, ma è stato un riferimento per tutta la Napa Valley sin dal suo inizio nel 1979. Se vuoi un vino che sia più grande della somma delle sue parti, allora parliamo di Opus One.
                    </div>

                    <div class="howto-title2">Un sogno condiviso</div>
                    <div class="howto-text">
                        Nato da un'idea di due amici di lunga data, Opus One mescola il savoir-faire del vecchio mondo con
                        le abilità enologiche del nuovo. Gli amici erano ovviamente il barone Philippe de Rothschild e
                        Roberto Mondavi. Dopo un incontro casuale alle Hawaii nel 1970, questi due giganti della vinificazione si sono messi in moto
                        concepire un vino che fosse un'espressione uguale di entrambi i loro stili. Dopo quasi un decennio
                        di deliberazione, hanno prodotto la loro prima annata, coltivata dai 14 ettari che aveva Mondavi
                        donato per la joint venture dal suo vigneto To Kalon. I viticoltori erano Rothschild
                        Lucien Sionneau e Timothy Mondavi (figlio ed enologo) di Mondavi.
                    </div>

                    <div class="howto-title2">L'opera ha vinto</div>
                    <div class="howto-text">
                        Non sorprende che il vino sia diventato un successo immediato, tanto più che le prime due annate (1979
                        e 1980) sono stati trattenuti dalla vendita pubblica. La prima uscita, nel 1981, divenne la più importante della California
                        vino costoso dopo che una cassa è stata venduta all'asta per $ 24.000. Quando le annate 1979 e 1980
                        sono stati rilasciati contemporaneamente, hanno rapidamente seguito l'esempio, valutando il vino come il primo
                        Vino californiano da considerare cult.
                    </div>

                    <div class="howto-title2">Una Napa francese</div>
                    <div class="howto-text">
                        Quarant'anni dopo, Opus One continua a rafforzarsi. Questo ha in parte a che fare con
                        la ricerca senza compromessi dell'eccellenza del vigneto, ma anche in parte ha a che fare con l'unicità
                        personaggio di Opus One. È un Mondavi? È un Mouton? No, è Opus One. Le uve sono ordinate per
                        mano, le botti vengono spesso travasate, non vengono utilizzate pompe meccanizzate per spostare il vino e francesi
                        i barili non vengono mai riutilizzati. Il vino è fatto come per tutti i vini della riva sinistra, con Merlot e Cabernet
                        dominare la miscela.
                    </div>

                    <div class="howto-title2">Il futuro di Opus One</div>
                    <div class="howto-text">
                        Il colosso americano delle bevande Constellation Brands ha rilevato la quota del 50% di Mondavi in Opus One nel 2004
                        quando hanno acquistato l'intera tenuta Mondavi per 1,36 miliardi di dollari. Rothchild possiede ancora l'altro
                        la metà, nonostante la costante speculazione che una parte rileverà la quota dell'altra. Guarda questo
                        spazio.
                    </div>

                    <div class="howto-title2">Fatti e annate notevoli</div>
                    <div class="howto-text">
                        <ul>
                            <li>Il vigneto produce solo due vini: Opus One e Overture. Il secondo vino prende il nome
                                dopo il movimento orchestrale degli inizi, promettendo qualcosa di più importante in seguito
                                SU.
                            </li>
                            <li>Nonostante il suo prezzo elevato, secondo winesearcher.com, Opus One rimane il marchio americano
                                vino più cercato (ed è il settimo vino più cercato al mondo).
                            </li>
                            <li>Il primo vino non europeo di Vindome è l'Opus One 2017. Con un punteggio complessivo di 95+
                                punti (da Suckling, Parker e Galloni), il vino è la degna conclusione della trilogia
                                iniziato nel 2015. L'Opus One 2017 è una bellezza densa e dovrebbe mantenersi bene per
                                almeno un altro decennio.
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Opus One</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Man sagt, dass man sein erstes nie vergisst. Und als erster amerikanischer Wein, der auf der Vindome-Plattform eingeführt wurde, halten wir Opus One für ziemlich unvergesslich. Er ist nicht nur einer der begehrtesten Weine der Welt, sondern seit seiner Einführung im Jahr 1979 eine Referenz für das gesamte Napa Valley. Wenn Sie einen Wein wollen, der mehr ist als die Summe seiner Teile, dann lassen Sie uns über Opus One sprechen.
                    </div>

                    <div class="howto-title2">Ein gemeinsamer Traum</div>
                    <div class="howto-text">
                        Opus One ist die Idee zweier langjähriger Freunde und vereint das Savoir-faire der alten Welt mit
                        die Winzerfähigkeiten des Neuen. Die Freunde waren natürlich Baron Philippe de Rothschild und
                        Robert Mondavi. Nach einem zufälligen Treffen auf Hawaii im Jahr 1970 machten sich diese beiden Winzergiganten auf den Weg
                        einen Wein zu konzipieren, der beide Stile gleichermaßen zum Ausdruck bringt. Nach fast einem Jahrzehnt
                        Nach Überlegung produzierten sie ihren ersten Jahrgang, angebaut auf den 14 Hektar, die Mondavi besaß
                        spendete für das Joint Venture von seinem To Kalon-Weinberg. Die Winzer waren Rothschilds
                        Lucien Sionneau und Mondavis (Sohn und Winzer) Timothy Mondavi.
                    </div>

                    <div class="howto-title2">Opus hat gewonnen</div>
                    <div class="howto-text">
                        Es überrascht nicht, dass der Wein sofort ein Erfolg wurde, noch mehr als die ersten beiden Jahrgänge (1979).
                        und 1980) wurden vom öffentlichen Verkauf ausgeschlossen. Die erste Veröffentlichung im Jahr 1981 wurde die meistverkaufte in Kalifornien
                        teurer Wein, nachdem eine Kiste für 24.000 US-Dollar versteigert wurde. Bei den Jahrgängen 1979 und 1980
                        wurden gleichzeitig herausgebracht, sie folgten schnell diesem Beispiel und bewerteten den Wein als den ersten
                        Kalifornischer Wein gilt als Kult.
                    </div>

                    <div class="howto-title2">Ein französischer Napa</div>
                    <div class="howto-text">
                        Vierzig Jahre später ist Opus One immer erfolgreicher geworden. Dies hat zum Teil damit zu tun
                        das kompromisslose Streben des Weinbergs nach Exzellenz, aber auch zum Teil mit dem ganz Einzigartigen
                        Charakter von Opus One. Ist es ein Mondavi? Ist es ein Mouton? Nein, es ist Opus One. Die Trauben werden nach sortiert
                        Andererseits werden Fässer häufig abgefüllt, es werden keine mechanisierten Pumpen verwendet, um den Wein zu bewegen, und Französisch
                        Fässer werden niemals wiederverwendet. Der Wein wird wie alle Weine des linken Ufers hergestellt, mit Merlot und Cabernet
                        dominiert die Mischung.
                    </div>

                    <div class="howto-title2">Die Zukunft von Opus One</div>
                    <div class="howto-text">
                        Der amerikanische Getränkeriese Constellation Brands übernahm 2004 den 50-prozentigen Anteil von Mondavi an Opus One
                        als sie das gesamte Mondavi-Anwesen für 1,36 Milliarden Dollar kauften. Rothchild besitzt immer noch den anderen
                        die Hälfte, trotz ständiger Spekulationen, dass eine Partei den Anteil der anderen übernehmen wird. Schau dir das an
                        Raum.
                    </div>

                    <div class="howto-title2">Bemerkenswerte Fakten und Jahrgänge</div>
                    <div class="howto-text">
                        <ul>
                            <li>Der Weinberg produziert nur zwei Weine: Opus One und Overture. Der Zweitwein wird benannt
                                nach dem Orchestersatz der Anfänge, der später etwas Wichtigeres verspricht
                                An.
                            </li>
                            <li>Trotz seines hohen Preises bleibt Opus One laut winesearcher.com Amerikas Favorit
                                am häufigsten nach Wein gesucht wird (und weltweit an siebthäufigster Stelle nach Wein gesucht wird).
                            </li>
                            <li>Vindomes erster außereuropäischer Wein ist der Opus One 2017. Mit einer Gesamtpunktzahl von 95+
                                Punkte (von Suckling, Parker und Galloni) bildet der Wein den würdigen Abschluss der Trilogie
                                Das begann im Jahr 2015. Der Opus One von 2017 ist eine dichte Schönheit und sollte sich noch lange halten
                                mindestens noch ein Jahrzehnt.
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Opus Uno</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Dicono che non dimentichi mai il tuo primo. E come primo vino americano lanciato sulla piattaforma Vindome, pensiamo che Opus One sia davvero indimenticabile. Non solo è uno dei vini più ambiti al mondo, ma è stato un riferimento per tutta la Napa Valley sin dal suo inizio nel 1979. Se vuoi un vino che sia più grande della somma delle sue parti, allora parliamo di Opus One.
                    </div>

                    <div class="howto-title2">Un sogno condiviso</div>
                    <div class="howto-text">
                        Nato da un'idea di due amici di lunga data, Opus One mescola il savoir-faire del vecchio mondo con
                        le abilità enologiche del nuovo. Gli amici erano ovviamente il barone Philippe de Rothschild e
                        Roberto Mondavi. Dopo un incontro casuale alle Hawaii nel 1970, questi due giganti della vinificazione si sono messi in moto
                        concepire un vino che fosse un'espressione uguale di entrambi i loro stili. Dopo quasi un decennio
                        di deliberazione, hanno prodotto la loro prima annata, coltivata dai 14 ettari che aveva Mondavi
                        donato per la joint venture dal suo vigneto To Kalon. I viticoltori erano Rothschild
                        Lucien Sionneau e Timothy Mondavi (figlio ed enologo) di Mondavi.
                    </div>

                    <div class="howto-title2">L'opera ha vinto</div>
                    <div class="howto-text">
                        Non sorprende che il vino sia diventato un successo immediato, tanto più che le prime due annate (1979
                        e 1980) sono stati trattenuti dalla vendita pubblica. La prima uscita, nel 1981, divenne la più importante della California
                        vino costoso dopo che una cassa è stata venduta all'asta per $ 24.000. Quando le annate 1979 e 1980
                        sono stati rilasciati contemporaneamente, hanno rapidamente seguito l'esempio, valutando il vino come il primo
                        Vino californiano da considerare cult.
                    </div>

                    <div class="howto-title2">Una Napa francese</div>
                    <div class="howto-text">
                        Quarant'anni dopo, Opus One continua a rafforzarsi. Questo ha in parte a che fare con
                        la ricerca senza compromessi dell'eccellenza del vigneto, ma anche in parte ha a che fare con l'unicità
                        personaggio di Opus One. È un Mondavi? È un Mouton? No, è Opus One. Le uve sono ordinate per
                        mano, le botti vengono spesso travasate, non vengono utilizzate pompe meccanizzate per spostare il vino e francesi
                        i barili non vengono mai riutilizzati. Il vino è fatto come per tutti i vini della riva sinistra, con Merlot e Cabernet
                        dominare la miscela.
                    </div>

                    <div class="howto-title2">Il futuro di Opus One</div>
                    <div class="howto-text">
                        Il colosso americano delle bevande Constellation Brands ha rilevato la quota del 50% di Mondavi in Opus One nel 2004
                        quando hanno acquistato l'intera tenuta Mondavi per 1,36 miliardi di dollari. Rothchild possiede ancora l'altro
                        la metà, nonostante la costante speculazione che una parte rileverà la quota dell'altra. Guarda questo
                        spazio.
                    </div>

                    <div class="howto-title2">Fatti e annate notevoli</div>
                    <div class="howto-text">
                        <ul>
                            <li>Il vigneto produce solo due vini: Opus One e Overture. Il secondo vino prende il nome
                                dopo il movimento orchestrale degli inizi, promettendo qualcosa di più importante in seguito
                                SU.
                            </li>
                            <li>Nonostante il suo prezzo elevato, secondo winesearcher.com, Opus One rimane il marchio americano
                                vino più cercato (ed è il settimo vino più cercato al mondo).
                            </li>
                            <li>Il primo vino non europeo di Vindome è l'Opus One 2017. Con un punteggio complessivo di 95+
                                punti (da Suckling, Parker e Galloni), il vino è la degna conclusione della trilogia
                                iniziato nel 2015. L'Opus One 2017 è una bellezza densa e dovrebbe mantenersi bene per
                                almeno un altro decennio.
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Opus One</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        They say you never forget your first. And as the first American wine to be launched on the Vindome platform, we think Opus One is pretty unforgettable. Not only is it one of the world’s most coveted wines, but its been a reference for all of Napa Valley since its inception in 1979. If you want a wine that is greater than the sum of its parts, then let’s talk about Opus One.
                    </div>

                    <div class="howto-title2">A shared dream</div>
                    <div class="howto-text">
                        The brainchild of two longtime friends, Opus One mixes the savoir-faire of the old world with
                        the winemaking skills of the new. The friends were of course Baron Philippe de Rothschild and
                        Robert Mondavi. After a chance meeting in Hawaii in 1970, these two winemaking giants set about
                        conceiving a wine that would be an equal expression of both their styles. After almost a decade
                        of deliberation, they produced their first vintage, grown from the 14 hectares that Mondavi had
                        donated for the joint venture from his To Kalon vineyard. The winemakers were Rothschild’s
                        Lucien Sionneau and Mondavi’s (son and winemaker) Timothy Mondavi.
                    </div>

                    <div class="howto-title2">Opus won</div>
                    <div class="howto-text">
                        Unsurprisingly, the wine became an instant success, even more so as the first two vintages (1979
                        and 1980) were held back from public sale. The first release, in 1981 became California’s most
                        expensive wine after a case was sold at auction for $24,000. When the 1979 and 1980 vintages
                        were released simultaneously, they quickly followed suit, benchmarking the wine as the first
                        Californian wine to be considered cult.
                    </div>

                    <div class="howto-title2">A French Napa</div>
                    <div class="howto-text">
                        Forty years on and Opus One continues to go from strength to strength. This is partly to do with
                        the vineyard’s uncompromising pursuit of excellence but also partly to do with the very unique
                        character of Opus One. Is it a Mondavi? Is it a Mouton? No, it’s Opus One. Grapes are sorted by
                        hand, barrels are frequently racked, no mechanized pumps are used to move the wine, and French
                        barrels are never reused. The wine is made as per all left bank wines, with Merlot and Cabernet
                        dominating the blend.
                    </div>

                    <div class="howto-title2">The future of Opus One</div>
                    <div class="howto-text">
                        The American drinks giant Constellation Brands took over Mondavi’s 50% share in Opus One in 2004
                        when they bought the entire Mondavi estate for $1.36 billion. Rothchild still owns the other
                        half, despite constant speculation that one party will take over the other’s share. Watch this
                        space.
                    </div>

                    <div class="howto-title2">Notable facts and vintages</div>
                    <div class="howto-text">
                        <ul>
                            <li>The vineyard produces just two wines: Opus One and Overture. The second wine is named
                                after the orchestral movement of beginnings, promising something more important later
                                on.
                            </li>
                            <li>Despite its hefty price tag, according to winesearcher.com, Opus One remains America’s
                                most searched for wine (and is the seventh most searched for wine worldwide).
                            </li>
                            <li>Vindome’s first non-European wine is the Opus One 2017. Scoring an across board 95+
                                points (from Suckling, Parker and Galloni), the wine is the fitting end to the trilogy
                                that started in 2015. The 2017 Opus One is a dense beauty and should keep well for at
                                least another decade.
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "KapcsandyWinery",
    head: {
        title: 'Opus One | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the premium wine of Opus One, a world-renowned wine producer in Napa Valley. Experience the blend of old world winemaking traditions and innovative technology to produce the finest wine. Indulge in the rich, complex and full-bodied flavors of the exceptional Opus One wines.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    },
    data() {
        return {
            select: {report: 'Opus One', src: '/wine-guide/usa/napa/opus-one'},
            items: [
                {report: 'Abreu Vineyards', src: '/wine-guide/usa/napa/abreu-vineyards'},
                {report: 'Caymus vineyards', src: '/wine-guide/usa/napa/caymus-vineyards'},
                {report: 'Christian Moueix - Dominus', src: '/wine-guide/usa/napa/christian-moueix-dominus'},
                {report: 'Colgin Cellars', src: '/wine-guide/usa/napa/colgin-cellars'},
                {report: 'Harlan Estates', src: '/wine-guide/usa/napa/harlan-estates'},
                {report: 'Kapcsandy Winery', src: '/wine-guide/usa/napa/kapcsandy-winery'},
                {report: 'Opus One', src: '/wine-guide/usa/napa/opus-one'},
                {report: 'Robert Mondovi Vineyards', src: '/wine-guide/usa/napa/robert-mondovi-vineyards'},
                {report: 'Scarecrow Wines', src: '/wine-guide/usa/napa/scarecrow-wines'},
                {report: 'Schrader Cellars', src: '/wine-guide/usa/napa/schrader-cellars'},
                {report: 'Screaming Eagle', src: '/wine-guide/usa/napa/screaming-eagle'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
